import config from 'shared/config'

export function buildMyIdOAuthStringACME(returnTo?: string): string {
    const genTokenURI = `${config.discoveryServiceUrl}/auth/cwr/generateToken`
    const inferredHost = `${window.location.protocol}//${window.location.host}`
    const host = process.env.PUBLIC_URL || inferredHost

    const paramsObj: { redirectUri: string; returnTo?: string } = {
        redirectUri: host,
    }

    if (returnTo) {
        paramsObj.returnTo = encodeURIComponent(returnTo)
    }

    const params = new URLSearchParams(paramsObj)
    console.log(`${genTokenURI}?${params.toString()}`)

    return `${genTokenURI}?${params.toString()}`
}
